// extracted by mini-css-extract-plugin
export var clickableWrapper = "_1w-2";
export var placeholderIcon = "_1w-3";
export var thumbnailCanvas = "_1w-1";
export var thumbnailWrapper = "_1w-0";